export const SET_STEP = 'SET_STEP'
export const SET_TYPE = 'SET_TYPE'
export const SET_GRANULARITY = 'SET_GRANULARITY'
export const SET_GLOBAL_INFORMATIONS = 'SET_GLOBAL_INFORMATIONS'
export const SET_SHIPPING_INFORMATIONS = 'SET_SHIPPING_INFORMATIONS'
export const SET_PAYMENT_INFORMATIONS = 'SET_PAYMENT_INFORMATIONS'
export const SET_THIRD_PARTY_ALREADY_SETUP = 'SET_THIRD_PARTY_ALREADY_SETUP'

export const FREE_SUBSCRIPTION = 'FREE_SUBSCRIPTION'
export const START_SUBSCRIPTION = 'START_SUBSCRIPTION'
export const CHECK_SUBSCRIPTION = 'CHECK_SUBSCRIPTION'
export const RESET_SUBSCRIPTION = 'RESET_SUBSCRIPTION'
export const PROCEED_GIFT_PAYMENT = 'PROCEED_GIFT_PAYMENT'
export const LOG_PAYMENT_ERROR = 'LOG_PAYMENT_ERROR'
export const CANCEL_SUBSCRIPTION = 'CANCEL_SUBSCRIPTION'
